import React from "react";

import { cx } from "~/tools/class-variance";

export interface TimelineControlElementProps {
	x?: number;
	style?: React.CSSProperties;
	className?: string;
	children?: React.ReactNode;
}

export const TimelineControlElement: React.FC<TimelineControlElementProps> = ({
	x = 0,
	style,
	className,
	children,
}) => (
	<div
		className={cx("absolute", className)}
		style={{
			transform: `translateX(${x}px)`,
			...style,
		}}
	>
		{children}
	</div>
);
